import { useNavigate } from "react-router-dom";
import type { Group } from "@domaddress/shared";

interface Props {
  group: Group & { member_count?: number; can_manage?: boolean; view_access?: "full" | "directory" };
  onEdit: () => void;
  onDelete: () => void;
}

export default function GroupCard({ group, onEdit, onDelete }: Props) {
  const navigate = useNavigate();
  const canManage = group.can_manage !== false;

  return (
    <div className="group-card" onClick={() => navigate(`/groups/${group.id}`)}>
      <div className="group-card-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      </div>
      <div className="group-card-info">
        <h3 className="group-name">{group.name}</h3>
        {group.description && <p className="group-desc">{group.description}</p>}
        {group.email && <p className="group-desc" style={{ fontSize: "0.85em", opacity: 0.9 }}>{group.email}</p>}
        {group.view_access === "directory" && (
          <span className="group-count" style={{ display: "block", marginTop: 4, fontSize: "0.75rem", opacity: 0.9 }}>
            Alleen naam/rolweergave — geen volledige adressen
          </span>
        )}
        <span className="group-count">
          {group.member_count ?? 0}{" "}
          {(group.member_count ?? 0) === 1 ? "lid" : "leden"}
        </span>
      </div>
      {canManage && (
      <div className="group-card-actions" onClick={(e) => e.stopPropagation()}>
        <button className="btn-icon" onClick={onEdit} title="Bewerken">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
            <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z"/>
          </svg>
        </button>
        <button className="btn-icon btn-icon-danger" onClick={onDelete} title="Verwijderen">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="3,6 5,6 21,6"/><path d="M19,6l-1,14a2,2,0,0,1-2,2H8a2,2,0,0,1-2-2L5,6"/>
            <path d="M10,11v6"/><path d="M14,11v6"/><path d="M9,6V4h6v2"/>
          </svg>
        </button>
      </div>
      )}
    </div>
  );
}
